/* tslint:disable */
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HttpResponse} from '@angular/common/http';
import {Inject} from '@angular/core';
import {Injectable} from '@angular/core';
import {API_HOST} from '../api-host';
import {PostConfirmationResponse} from './post-confirmation.response';
import {PostConfirmationRequest} from './post-confirmation.request';
@Injectable()
export class ConfirmationGateway {
  constructor(private readonly _httpClient: HttpClient, @Inject(API_HOST) private readonly _apiHost: string) {}

  postConfirmation(
    body: PostConfirmationRequest,
    options?: Parameters<HttpClient['request']>[2],
  ): Observable<PostConfirmationResponse> {
    return this._httpClient.request('post', this._apiHost + '/confirmation', {
      ...options,
      observe: 'body',
      body,
    });
  }
}
